import React from "react";
import ReactDOM from "react-dom";
import IntroductionSection from "../components/IntroductionSection";
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderIntroductionSection = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<IntroductionSection props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering IntroductionSection:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
